import { useEffect, useState } from 'react'
import { surveyApi } from '../services/api'
import type { SurveyListItem } from '../types/survey'
import { SurveyList } from '../components/SurveyList'
import { Loading } from '../components/Loading'
import '../styles/home.css'

export function Home() {
  const [surveys, setSurveys] = useState<SurveyListItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    surveyApi
      .listSurveys()
      .then((res) => {
        if (!cancelled) {
          setSurveys(res.items)
          setLoading(false)
        }
      })
      .catch((err: Error) => {
        if (!cancelled) {
          setError(err.message)
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [])

  if (loading) return <Loading message="Loading available surveys..." />

  return (
    <main className="home-container">
      <header className="home-header">
        <h1 className="home-title">Available Surveys</h1>
        <p className="home-subtitle">Select a survey below to get started.</p>
      </header>

      {error ? (
        <div className="home-error" role="alert">
          <p>Failed to load surveys: {error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      ) : (
        <SurveyList surveys={surveys} />
      )}
    </main>
  )
}
